import { memo } from 'react';

import { useIncomingReferencesMap } from '@/context/incoming-references/incoming-references-context';
import { ReferencedIndicator } from '@/components/atoms/referenced-indicator/referenced-indicator';

type Props = {
  blockId: string;
  variant?: 'full' | 'compact';
};

function BlockReferencedIndicatorComponent({
  blockId,
  variant = 'full',
}: Props) {
  const count = useIncomingReferencesMap()[blockId] ?? 0;
  if (count <= 0) return null;
  return <ReferencedIndicator count={count} variant={variant} />;
}

const BlockReferencedIndicator = memo(BlockReferencedIndicatorComponent);

export { BlockReferencedIndicator };
